import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Home from "@/pages/Home";
import Resources from "@/pages/Resources";
import StrategyCall from "@/pages/StrategyCall";
import InfiniteBanking from "@/pages/InfiniteBanking";
import FinancialSolutions from "@/pages/FinancialSolutions";
import FamilyLegacy from "@/pages/FamilyLegacy";
import About from "@/pages/About";
import FAQs from "@/pages/FAQs";
import PolicyReview from "@/pages/PolicyReview";
import ThankYou from "@/pages/ThankYou";
import BudgetTemplateThankYou from "@/pages/BudgetTemplateThankYou";
import BudgetTemplateAccess from "@/pages/BudgetTemplateAccess";
import SaveSpendSystemAccess from "@/pages/SaveSpendSystemAccess";
import NewsletterThankYou from "@/pages/NewsletterThankYou";
import AdminSubmissions from "@/pages/AdminSubmissions";
import LegalPage from "@/pages/LegalPage";
import NotFound from "@/pages/NotFound";
import { LEGAL_DOCS } from "@/lib/legal";

function ScrollManager() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const t = setTimeout(() => {
        const el = document.querySelector(hash);
        if (el) el.scrollIntoView({ behavior: "smooth" });
        else window.scrollTo(0, 0);
      }, 80);
      return () => clearTimeout(t);
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollManager />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/resources" element={<Resources />} />
          <Route path="/strategy-call" element={<StrategyCall />} />
          <Route path="/infinite-banking" element={<InfiniteBanking />} />
          <Route path="/financial-solutions" element={<FinancialSolutions />} />
          <Route path="/family-legacy" element={<FamilyLegacy />} />
          <Route path="/about" element={<About />} />
          <Route path="/faqs" element={<FAQs />} />
          <Route path="/policy-review" element={<PolicyReview />} />
          <Route path="/resources/thank-you/7-simple-steps" element={<ThankYou freebieKey="7-steps" />} />
          <Route path="/resources/thank-you/legacy-builder-outline" element={<ThankYou freebieKey="legacy-builder" />} />
          <Route path="/resources/thank-you/infinite-banking-guide" element={<ThankYou freebieKey="infinite-banking-guide" />} />
          <Route path="/resources/thank-you/save-spend-overview" element={<ThankYou freebieKey="save-spend-overview" />} />
          <Route path="/resources/thank-you/budget-template-training" element={<BudgetTemplateThankYou />} />
          <Route path="/resources/budget-template-access" element={<BudgetTemplateAccess />} />
          <Route path="/resources/save-spend-system-access" element={<SaveSpendSystemAccess />} />
          <Route path="/resources/thank-you/newsletter" element={<NewsletterThankYou />} />
          <Route path="/admin/submissions" element={<AdminSubmissions />} />
          <Route path="/privacy" element={<LegalPage doc={LEGAL_DOCS.privacy} />} />
          <Route path="/terms" element={<LegalPage doc={LEGAL_DOCS.terms} />} />
          <Route path="/disclosures" element={<LegalPage doc={LEGAL_DOCS.disclosures} />} />
          <Route path="/accessibility" element={<LegalPage doc={LEGAL_DOCS.accessibility} />} />
          <Route path="/affiliate-disclosure" element={<LegalPage doc={LEGAL_DOCS["affiliate-disclosure"]} />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
